const Container = ({children}) => {
    return(
        <div className="flex flex-col w-9/12 sm:w-96 h-auto lg:flex-row h-132 lg:w-full lg:max-w-4xl">
            {children}
        </div>
    )
}

export default Container